import ContinueButton from './component.styles'
export default ContinueButton
